export default __webpack_public_path__ + "static/bora-bora-8abc1c98697a46aea6822a16bf36befe.jpg";